module.exports = new __parcel__URL__("icon-project.452d86c8.svg").toString();